// Central source of truth for Route Facile company facts.
// Owner-approved 2026-10-29 — single source, shared verbatim with Outrank.
// Any change comes from the manager only, applied in both places the same day.

const FACTS = {
  companyName: 'Route Facile',
  foundingYear: 2025,
  websiteUrl: 'https://routefacilecarrental.com',
  phone: '+212 655 585 859',
  whatsapp: '+212 655 585 859',
  email: 'info@routefacilecarrental.com',
  address: {
    locality: 'Marrakech',
    region: 'Marrakech-Safi',
    country: 'MA'
  },
  geo: { lat: 31.629472, lng: -7.981084 },

  // 1. Offices — exactly two. No branches in any other city.
  realBranches: ['Marrakech', 'Rabat'],
  offices: {
    en: 'Two offices only: Marrakech (Route d\'Amelkis, Dar Alameria) and Rabat (Hay Riad, head office).',
    fr: 'Deux bureaux seulement : Marrakech (Route d\'Amelkis, Dar Alameria) et Rabat (Hay Riad, siège principal).',
    ar: 'مكتبان فقط: مراكش (طريق أملكيس، دار ألاميريا) والرباط (حي الرياض، المقر الرئيسي).'
  },

  // 2. Delivery — free in ALL Moroccan cities and airports, to the airport,
  //    hotel, riad or any address, 24/7. Other cities by delivery only.
  deliveryCities: ['Casablanca', 'Agadir', 'Tanger', 'Fes', 'Oujda', 'Tetouan', 'Safi', 'El Jadida', 'Meknes', 'Kenitra'],
  deliveryFreeZone: ['Moroccan airports', 'Moroccan cities'],
  deliveryFeeNote: 'free delivery and collection at all Moroccan cities and airports, to the airport, hotel, riad or any address, 24/7',
  deliveryFees: {},
  delivery247: true,

  // 3. Return in another city — free.
  oneWayFree: true,

  // 4. No minimum or maximum duration may be stated in articles.
  //    "3 jours minimum" and "à partir de X jours" are both rejected.
  //    ALLOWED: trip day counts ("road trip Maroc 10 jours"), "location longue durée"
  //    as a service name, and booking-form UI labels.

  // 5. No deposit at all — no caution at booking or pickup, no blocked amount,
  //    no security cheque. No credit card required to book or to collect.
  noDepositOrSecurityCheque: true,
  noCreditCardRequired: true,
  depositPolicy: {
    en: 'No deposit and no security cheque to book or at handover.',
    fr: 'Aucune caution ni chèque de garantie à la réservation ni à la remise des clés.',
    ar: 'لا توجد وديعة ولا شيك ضمان عند الحجز ولا عند استلام السيارة.'
  },

  // 6. Insurance — full insurance included, with no amount charged to the
  //    customer (no franchise). We do NOT sell CDW or Super CDW.
  comprehensiveInsuranceIncluded: true,
  insuranceDeductibleDisclosed: true,
  insuranceFranchise: 'zero',
  sellsCdwSuperCdw: false,

  // 7. Mileage — unlimited and always included, not an optional extra.
  unlimitedMileage: true,

  // 8. Free inclusions — second driver, GPS in every car, no young-driver
  //    fees. Child seat is an extra fee.
  freeSecondDriver: true,
  gpsIncluded: true,
  noYoungDriverFee: true,
  childSeatExtraFee: true,

  // 9. Driver — age 21+, licence held 1+ year. Foreign licence alone accepted;
  //    international permit accepted but not mandatory.
  minimumDriverAgeYears: 21,
  licenceHeldYears: 1,

  // 10. Pickup documents — passport + driving licence. Moroccan residents:
  //     national ID card (CIN) + driving licence.

  // 11. Cancellation — free up to 24h before pickup, full refund of advance.

  // 12. Payment — online booking with 15% advance or 100% by card, or book and
  //     pay at pickup without a card. Booking also via WhatsApp.
  bookingPrepaymentPercentage: 15,
  bookingPrepaymentPercentageIsPublicCopy: true,
  paymentAccepted: 'Online (15% advance or 100% by card), or pay at pickup without a card',
  bookingByWhatsappAvailable: true,
  bookingPrepaymentIsSecurityDeposit: false,
  bookingCta: {
    en: 'Book and confirm your car online, or book through WhatsApp.',
    fr: 'Réservez et confirmez votre voiture en ligne, ou réservez via WhatsApp.',
    ar: 'احجز وأكّد سيارتك أونلاين، أو احجز عبر واتساب.',
  },

  // 13. Fleet — all automatic and modern.
  fleet: [
    'Hyundai i20',
    'Renault Clio 5',
    'Peugeot 208 Hybrid',
    'Dacia Duster',
    'Peugeot 2008 Hybrid',
    'VW T-Roc',
    'Hyundai Tucson',
    'Peugeot 3008 Hybrid',
    'VW Tiguan',
    'Range Rover Evoque'
  ],

  // 14. Not offered — chauffeur, organised tours. Self-drive rental only.
  //     7-seater cars, minibus and 4x4 are available (by city/season, confirm
  //     via WhatsApp; do not state a specific model or price; do not advise
  //     driving inside protected dunes).
  selfDriveOnly: true,
  notOffered: ['chauffeur', 'organised tours'],

  // 15. Prices — ~250 MAD (25€)/day long-term to ~1200 MAD (120€) luxury,
  //     varying by season and duration. No other prices or discounts; live
  //     price is on the site.
  priceRangeEurPerDay: { min: 25, max: 120 },
  priceRangeMadPerDay: { min: 250, max: 1200 },
  currenciesAccepted: 'MAD',

  rentalCountry: 'MA',
  openingHours: 'Mo-Su 00:00-23:59',
  services: ['No deposit or security cheque', 'Unlimited mileage', 'Comprehensive insurance included (no franchise)',
    'Free second driver', 'Free GPS', 'No young-driver fees', 'Free delivery and collection in all Moroccan cities and airports', '24/7 support'],
  sameAs: [
    'https://www.facebook.com/routefacilecarrental',
    'https://www.instagram.com/routefacilecarrental/',
    'https://www.linkedin.com/company/routefacile',
    'https://twitter.com/routefacile'
  ]
};

export default FACTS;
